import React from "react";

export function highlightVariables(template) {
  return template.split(/(\{[A-Z_]+\})/g).map((part, i) =>
    /^\{[A-Z_]+\}$/.test(part) ? (
      <code
        key={i}
        style={{
          background: "#f4f4f5",
          borderRadius: 4,
          color: "#7c3aed",
          fontWeight: 500,
          fontSize: "0.95em",
        }}
      >
        {part}
      </code>
    ) : (
      <span key={i}>{part}</span>
    ),
  );
}
